import * as React from "react";
import { MediaQuery, Util, Button } from "@grandvisionhq/common";
import { Heading, Text, Container } from "@grandvisionhq/elements";
/* empty css              */
const BlogHeroDesktop = ({
  title,
  summary,
  link,
  readMoreLabel,
  imageUrl
}) => /* @__PURE__ */ React.createElement(
  "div",
  {
    className: "blog-hero",
    style: Util.createCssImageSetStyle(
      imageUrl,
      1920,
      { fit: "fillmax" },
      {
        extraPixelDensities: [2],
        style: {
          backgroundPosition: "center",
          backgroundSize: "cover"
        }
      }
    )
  },
  /* @__PURE__ */ React.createElement(Container, { className: "site-container" }, /* @__PURE__ */ React.createElement("div", { className: "blog-hero__content" }, /* @__PURE__ */ React.createElement(Heading, { variant: "large", className: "blog-hero__title" }, title), summary && /* @__PURE__ */ React.createElement(Text, { className: "blog-hero__intro" }, Util.truncateString(summary, 150)), /* @__PURE__ */ React.createElement(
    Button,
    {
      size: "medium",
      href: link,
      className: "blog-hero__button",
      variant: "outline",
      caption: readMoreLabel,
      "aria-label": readMoreLabel
    }
  )))
);
const BlogHeroMobile = ({
  imageUrl,
  title,
  summary,
  link,
  readMoreLabel
}) => /* @__PURE__ */ React.createElement(
  "div",
  {
    className: "blog-hero-mobile",
    style: Util.createCssImageSetStyle(
      imageUrl ?? "",
      1024,
      { fit: "fillmax" },
      {
        extraPixelDensities: [2],
        style: {
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat"
        }
      }
    )
  },
  /* @__PURE__ */ React.createElement("div", { className: "blog-hero-mobile__content" }, /* @__PURE__ */ React.createElement(Heading, { variant: "medium", className: "blog-hero-mobile__title" }, title), summary && /* @__PURE__ */ React.createElement(Text, { className: "blog-hero-mobile__intro" }, summary), /* @__PURE__ */ React.createElement(
    Button,
    {
      size: "medium",
      href: link,
      className: "blog-hero-mobile__button",
      variant: "outline",
      caption: readMoreLabel,
      "aria-label": readMoreLabel
    }
  ))
);
const BlogHero = ({ mobileImage, image, ...rest }) => {
  const isSmallScreen = MediaQuery.useIsBelow(MediaQuery.BreakpointName.TABLET_LANDSCAPE);
  const imageUrl = isSmallScreen && mobileImage ? mobileImage.url : image?.url ?? "";
  if (isSmallScreen) {
    return /* @__PURE__ */ React.createElement(BlogHeroMobile, { ...rest, imageUrl });
  }
  return /* @__PURE__ */ React.createElement(BlogHeroDesktop, { ...rest, imageUrl });
};
const BlogHero$1 = React.memo(BlogHero);
export {
  BlogHero,
  BlogHero$1 as default
};
//# sourceMappingURL=BlogHero.js.map
